export default class BasicChartDataset {
    public label: string = "";
    public data: number[] = [];
    public borderWidth: number = 1;
    public backgroundColor: string[] = [];
    public borderColor: string[] = [];
    constructor(model: any = null) {
        if (model) {
            this.fill(model);
        }
    }

    /**
     * Fills the instance attributes from the given object if the necessary properties
     * are set up and available.
     */
    private fill(model: any) {
        if (model.label) {
            this.label = model.label;
        }
        if (model.borderWidth) {
            this.borderWidth = model.borderWidth;
        }
        if (model.data) {
            this.data = [];
            for(let i = 0; i < model.data.length; i++) {
                this.data.push(Number(model.data[i]));
            }
        }
    }
}
